import React, { useCallback, useEffect, useState, useMemo } from 'react'
import AUDIOS from './Whatsapp.data'
import Layout from '../layout'
import './Whatsapp.css'

// const changeElementVolume = (element, type) => {
//   switch (type) {
//     case 'increase': {
//       element.volume = Math.min(element.volume + 0.1, 1)
//       break
//     }
//     case 'decrease': {
//       element.volume = Math.max(element.volume - 0.1, 0)
//       break
//     }
//     default: break
//   }
// }

const WhatsappIcon = ({ playing }) => {
  const [hovered, setHovered] = useState(false)

  const src = useMemo(() => (
    playing || hovered
      ? '/assets/images/whatsapp_on.png'
      : '/assets/images/whatsapp_off.png'
  ), [playing, hovered])

  return (
    <img
      alt="Play sound"
      src={src}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      onClick={() => setHovered(false)}
    />
  )
}

const SoAnittaPodeAdd = () => {
  const [audios, setAudios] = useState({})
  const [curPlaying, setPlaying] = useState({})

  const togglePlaying = useCallback((id, value) => {
    setPlaying((old) => ({ ...old, [id]: value }))
  }, [])

  // const onChangeVolume = useCallback((type) => {
  //   Object.keys(audios).forEach((id) => {
  //     changeElementVolume(audios[id].element, type)
  //   })
  // }, [audios])

  const onClickIcon = useCallback((id) => {
    const { element } = audios[id]

    if (element.paused) {
      element
        .play()
        .catch((e) => console.warn('failed to play whatsapp', e))
      togglePlaying(id, true )

      return
    }

    element.currentTime = 0
    element.pause()
    togglePlaying(id, false)
  }, [audios, togglePlaying])

  useEffect(() => {
    const loadAudios = AUDIOS.reduce((prev, audio) => {
      const element = new Audio(audio.src)

      element.addEventListener('ended', () => togglePlaying(audio.id, false))

      return {
        ...prev,
        [audio.id]: { ...audio, element }
      }
    }, [])

    setAudios(loadAudios)

    return () => {
      Object.keys(loadAudios).map((id) => {
        const audio = loadAudios[id]

        audio.element.currentTime = 0
        audio.element.pause()
        if (audio.element) {
          audio.element.removeEventListener(
            'ended',
            () => togglePlaying(audio.id, false),
          )
        }

        return false
      })
    }
  }, [togglePlaying])

  return (
    <Layout className="g-wpp-layout">
      <div className="g-wapp-wrap">
        {Object.keys(audios).map((id) => (
          <div key={id} className="g-wapp-audio" onClick={() => onClickIcon(id)}>
            <WhatsappIcon playing={curPlaying[id]} />
          </div>
        ))}
      </div>
    </Layout>
  )
}

export default SoAnittaPodeAdd
